import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

function Rules() {
    const rules = [
        {
            title: 'Hoe werkt de veiling?',
            text: `Op vrijdag 29 augustus gaan 36 deelnemers hun team bij elkaar veilen. Om 20:00 uur is de inloop, om 20:15 uur wordt de winnaar van vorig jaar nog even gehuldigd, 20:30 uur gaan we beginnen! Elke deelnemer heeft in de veiling 120 euro te besteden plus een blinde pool add-on van 10 euro. Zij moeten daar 11 spelers van veilen plus een coach. Het bod wat het hoogste is wint de speler en plaatst hem daarmee in zijn selectie. In de blinde poule kan hij er dan nog 1 bij veilen via de add-on.

De blinde pool zal via de app worden voortgezet.

De selecties zullen te zien zijn in de Web App, ook zichtbaar voor je concurrenten. Een team bestaat uit 11 spelers plus de coach (zie pagina Team). Er wordt ook dit jaar volgens een ranglijst gespeeld, met H2H systeem in wedstrijden. Het wedstrijdschema wordt geloot via de app. In de H2H kan je kiezen voor een bepaalde team samenstelling om je tegenstander af te troeven.(zie pagina H2H)

De Nr 1 t/m 15 gaat rechtstreeks naar de KO fase. De nummer 16 t/m 36 gaan via de play off ronde strijden voor het laatste ticket. De uitgeschakelde deelnemers kunnen hun spelers op de transferlijst zetten voor tot 15% van het prijzengeld. Hierdoor hebben we 16 teams die in de KO fase komen & H2H spelers voor de Final 8. Na de achtste finales gaan we vanaf de kwartinale door in ranglijst vorm.

Een team kan punten behalen via een puntentelling zoals een goal scoren of de nul houden (zie pagina De Puntentelling).`
        },
        {
            title: 'Waar moet een team aan voldoen?',
            text: `Elk team moet aan de volgende regels voldoen:

11 spelers plus een coach
Er zijn geen restricties aan nationaliteit of team
1 captain die variabel is tijdens het spel, doorgegeven voor elke speelronde
Minimaal 1 keeper
Minimaal 3 – maximaal 5 verdedigers
Minimaal 3 – maximaal 5 middenvelders
Minimaal 2 – maximaal 4 aanvallers

Je mag zeven keer in het toernooi een speler ‘’uitzwaaien’’ en daar een andere speler voor in de plaats nemen. Een uitgeschakelde speler kan je in de KO fase nog wisselen. De biedingen worden bijgehouden in de app.

Een deel van de poulefase wordt gespeeld tijdens de Winterse transfermarkt. Mocht jouw speler worden verkocht aan een non-CL deelnemer dan krijg je 1 gartis wissel.`
        },
        {
            title: 'Strategie – Linie formatie',
            text: `Ook dit jaar gaan de deelnemers een linie formatie bepalen aan de hand van de selectie van de tegenstander. Zie jij bijv. Lewandowski staan bij de tegenstander, maar een matige verdediging dan kan je ervoor kiezen om druk te zetten op die verdediging met de strategie ‘’Mourinho’s Bus’’. Jouw puntentotaal van de verdedigers wordt dan vergeleken met het punten totaal van de verdedigers van je tegenstander. Hier kan je 8 extra punten mee verdienen. Als je de strategie van je tegenstander kraakt kan je nog 8 extra punten verdienen. Oftewel heeft hij dominant ingesteld en jij pakt meer middenveld punten dan kraak jij zijn strategie.

Mocht je je strategie vergeten of niet aangepast hebben dan behoud je de strategie van de laatst gespeelde speelronde.

De strategiekeuzes:
- Nederlands Totaal voetbal: Het puntenaantal van jouw aanvallers wordt vergeleken met het puntenaantal van de aanvallers van je tegenstander.
- Dominant Barcelona voetbal: Het puntenaantal van jouw middenvelders wordt vergeleken met het puntenaantal van de middenvelders van je tegenstander.
- Mourinho’s Bus: Het puntenaantal van jouw verdedigers wordt vergeleken met het puntenaantal van de verdedigers van je tegenstander.
- Italiaans Cattenaccio voetbal: Het puntenaantal van jouw coach, keeper & aanvoerder wordt vergeleken met het puntenaantal van de coach, keeper & aanvoerder van je tegenstander. Een keeper kan je hier geen aanvoerder maken!`
        },
        {
            title: 'The Draft',
            text: `In Februari zullen 16 deelnemers uitgeschakeld worden in de poulefase. Dit jaar is er opnieuw geen verliezersronde voor hen MAAR: Zij kunnen nog geld terugverdienen door spelers te verkopen aan de 16 overgebleven deelnemers. Dit kan voor een aandelen percentage (max 15%) van het toekomstige prijzengeld van de nieuwe eigenaar.

Dus stel Mbappe zit bij Haakson & Haakson is uitgeschakeld. Haakson kan Mbappe dan voor een aandelenpercentage op de draftlijst zetten voor max 15%. Dit kan hij doen met maximal 3 spelers uit zijn selectie, de rest wordt teruggegeven aan de bank.

De verkoop zal gebeuren in draft vorm, hier wordt voor geloot via de app. We gaan heen en terug, oftewel ieder van de 16 deelnemers kan hooguit 2 spelers omruilen (reeds uitgeschakelde spelers kunnen geruild worden na de draft). De rest van de selectie van de uitgeschakelde (9 spelers) gaat de bank in. Zo kan iedereen er ook gemakkelijk voor kiezen om 100% te behouden. Je kan in de Draft geen 2 spelers nemen van dezelfde club.`
        },
        {
            title: 'Na de veiling; de blinde pool!',
            text: `Er worden zoals eerder gezegd 350 voetballers geveild, dit zijn natuurlijk bij lange na niet alle spelers van de CL vandaar: De Blinde Pool.

• De blinde pool is een pool van voetballers die niet geveild zijn
• Als een speler niet aan de minimale voorwaarden voldoet op de avond zelfs, dan moet hij dit compenseren in de blinde pool
• Er kan additioneel 10 euro (add-on) bij betaald worden bij het budget; te besteden aan de blinde pool
• Het minimale bod in de blinde pool is 1 euro voor een speler, dit kan je betalen uit het budget dat nog over is of de additionele 10 euro
• Bieden kan alleen per hele euro en doe je d.m.v. de app
• Bij een gelijk bod wordt er gekeken wie er als eerst heeft geboden
• Er kan geboden worden in de blinde pool tot iedereen vol zit (meerdere rondes).`
        }
    ];

    return (
        <Box>
            <Typography variant="h4" gutterBottom>Spelregels</Typography>
            <Paper sx={{ p: 3 }}>
                {rules.map((rule, index) => (
                    <Box key={index} sx={{ mb: 3 }}>
                        <Typography variant="h5" gutterBottom>{rule.title}</Typography>
                        <Typography sx={{ whiteSpace: 'pre-wrap' }}>
                            {rule.text}
                        </Typography>
                    </Box>
                ))}
            </Paper>
        </Box>
    );
}

export default Rules;